import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/admin/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$slug/admin/operators", params })
  },
})
